import React from 'react'
import Button from '../../../Components/Button'
import { formatPrice } from '../utils/formatters'

export default function BookingSummary({ total, perPerson, partySize, flatTotal = 0, venueHireFeePence = 0, onContinue, disabled, disabledHint, label = 'Continue' }) {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl shadow-[0_-4px_16px_rgba(0,0,0,0.12)] px-4 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]" role="region" aria-label="Booking summary">
      <div className="max-w-2xl mx-auto">
        <div className="flex items-center justify-between mb-2">
          <div className="text-sm text-gray-600">
            <span>{formatPrice(perPerson)} pp × {partySize} {partySize === 1 ? 'guest' : 'guests'}</span>
            {flatTotal > 0 && (
              <span> + {formatPrice(flatTotal)}</span>
            )}
            {venueHireFeePence > 0 && (
              <span> + {formatPrice(venueHireFeePence)} venue hire</span>
            )}
          </div>
          <div className="text-lg font-bold text-sky-900" aria-live="polite">
            {formatPrice(total)}
          </div>
        </div>
        <Button
          onClick={onContinue}
          disabled={disabled}
          variant="primary"
          theme="dark"
          size="lg"
          fullWidth
        >
          {label}
        </Button>
        {disabled && disabledHint && (
          <p className="text-sm text-gray-500 text-center mt-2">{disabledHint}</p>
        )}
      </div>
    </div>
  )
}
